/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */

const RegexCollection = {
    alphabetic: /^[a-zA-Z\s]*$/,
    phoneNumber: /^(\+\d{1,4}[\s-]?)?(\(?\d{1,5}\)?)?[\s.-]?\d{1,5}[\s.-]?\d{1,9}$/,
};

export default RegexCollection;
